export default "__VITE_ASSET__95bbb481__"